'use client';

import { useState } from 'react';

import { useSearchParamsContext } from '@/contexts/search-params-context';
import { useMediaQuery } from '@/hooks/use-media-query';
import { getFilterCount } from '@/lib/utils';

import { HeaderFiltersDesktop } from './header-filters-desktop';
import { HeaderFiltersMobile } from './header-filters-mobile';

export const HeaderFilters = () => {
  const [isOpen, setIsOpen] = useState(false);
  const isDesktop = useMediaQuery('(min-width: 1024px)');
  const { filters, clearFilters, applyFilters } = useSearchParamsContext();

  const filterCount = getFilterCount(filters);

  const handleApplyFilters = () => {
    applyFilters();
    setIsOpen(false);
  };

  return (
    <>
      {isDesktop ? (
        <HeaderFiltersDesktop
          filterCount={filterCount}
          clearFilters={clearFilters}
          handleApplyFilters={handleApplyFilters}
          isOpen={isOpen}
          setIsOpen={setIsOpen}
        />
      ) : (
        <HeaderFiltersMobile
          filterCount={filterCount}
          clearFilters={clearFilters}
          handleApplyFilters={handleApplyFilters}
          isOpen={isOpen}
          setIsOpen={setIsOpen}
        />
      )}
    </>
  );
};
